/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Tbl from '@appblocks/codegeneration/Libraries/Tbl';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    const name = feature.getSettingValue('NAME');
    const MAXRECORDS = feature.getSettingValue('MAXRECORDS');
    const STRUCT = feature.getSettingValue('STRUCT');
    const KEYFIELDS = feature.getSettingValue('KEYFIELDS');
    const COMMENT = feature.getSettingValue('COMMENT');
    let fields = '';
    const allFields = feature.getSettingValue('FIELDS');
    for (let i = 0; i < allFields.length; i += 1) {
        fields += `${allFields[i].getCodeBlocks()[0].template}\n`;
    }

    blocks.push({
        location: 'TABLES_XTXT',
        blockType: BlockType.CODE,
        template: `
==${name}\t${MAXRECORDS}\t${STRUCT}\t${KEYFIELDS}\t${COMMENT}
${fields}`,
    });
    if (feature.getSettingValue('AGGENABLED')) {
        blocks.push({
            location: 'TABLES_XTXT',
            blockType: BlockType.CODE,
            template: '>>AEL\tB\t0\t5\t0\tA-event Level',
        });
    }
    return blocks;
};
